package amazon.lastmile.inject

import app.nestbridge.feature.children.presentation.CreateChildProfilePresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = CreateChildProfilePresenterFactory::class)
public interface AppNestbridgeFeatureChildrenPresentationCreateChildProfilePresenterFactory {
  @Provides
  @IntoSet
  public fun provideCreateChildProfilePresenterFactoryFactoryMultibinding(createChildProfilePresenterFactory: CreateChildProfilePresenterFactory): Presenter.Factory = createChildProfilePresenterFactory
}
